import { render, staticRenderFns } from "./ItemType.vue?vue&type=template&id=0ee8fa9f&"
import script from "./ItemType.vue?vue&type=script&lang=js&"
export * from "./ItemType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports